module.exports = __webpack_public_path__ + "img/1547102871.2fe034c2.jpg";